import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // 1. Check URL parameter first (for Google Ads etc.)
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    if (urlLang === 'en' || urlLang === 'de') {
      // Save to localStorage so it persists during navigation
      localStorage.setItem('dion-language', urlLang);
      return urlLang;
    }
    
    // 2. Check localStorage
    const saved = localStorage.getItem('dion-language');
    if (saved) return saved;
    
    // 3. Default to German (as per client request)
    return 'de';
  });

  useEffect(() => {
    localStorage.setItem('dion-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'de' ? 'en' : 'de');
  };

  const setLang = (lang) => {
    if (lang === 'de' || lang === 'en') {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: setLang, 
      toggleLanguage,
      isGerman: language === 'de',
      isEnglish: language === 'en'
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
